import axios from "axios";
import { Loading, Notify } from "notiflix";
import { APIURL } from "./config";
import { REPORT_CARD, REPORT_CARD_DETAILS, SEARCH_STUDENT_LIST, STUDENT_REPORT_LIST, } from "./types";
import { isJsonString } from "../../helper";

export const studentReportList = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/student-reports`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: STUDENT_REPORT_LIST, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: STUDENT_REPORT_LIST,
            payload: {},
         });
      } else if (!res?.data?.status) {
         dispatch({
            type: STUDENT_REPORT_LIST,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const getReportCard = (params) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      },
      data: {}
   };
   const queryString = typeof (params) === 'object' ? Object.keys(params).map(key => `${key}=${params[key]}`).join('&') : '';
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/school-dashboard/view/kid-reportcard?${queryString}`, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: REPORT_CARD,
            payload: res?.data?.body,
         });
      } else if (!res?.data?.status) {
         dispatch({
            type: REPORT_CARD,
            payload: {},
         });
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const reportCardDetails = (params, cb) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   }
   const queryString = typeof (params) === 'object' ? Object.keys(params).map(key => `${key}=${params[key]}`).join('&') : '';
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/reportcard/details-list?${queryString}`, {}, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: REPORT_CARD_DETAILS,
            payload: res?.data?.body,
         });
         if (cb) cb(res?.data?.body);
      } else if (!res?.data?.status) {
         dispatch({
            type: REPORT_CARD_DETAILS,
            payload: {},
         });
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const updateReportCard = (data, cb) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   }

   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/save/reportcard`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ? res?.data?.message : "Report card updated successfully!"
         Notify.success(message);
         if (cb) cb();
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const searchStudent = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/report-student-name`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: SEARCH_STUDENT_LIST, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: SEARCH_STUDENT_LIST,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const reportCardDownload = (data) => async dispatch => {
   const config = {
      responseType: 'arraybuffer',
      headers: {
         'Content-Type': 'application/json',
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/download/reportcard/zip`, data, config);
      Loading.remove();
      if (res?.status == 200) {
         const arrayBuffer = res.data;
         const decoder = new TextDecoder('utf-8');
         const json = decoder.decode(arrayBuffer);
         if (isJsonString(json)) {
            const jData = JSON.parse(json);
            Notify.warning(jData?.message)
         } else {
            const disposition = res.request.getResponseHeader('Content-Disposition')
            var fileName = "";
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
               fileName = matches[1].replace(/['"]/g, '');
            }
            let blob = new Blob([res.data], { type: 'application/zip' })
            const downloadUrl = URL.createObjectURL(blob)
            let a = document.createElement("a");
            a.href = downloadUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            const message = res?.data?.message ? res?.data?.message : "Report card downloaded successfully!"
            Notify.success(message);
         }
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}